// Copyright (C) 2023 Cochise Ruhulessin
// 
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import axios, { AxiosInstance } from 'axios'


class CurrentUser {
    claims: any
  
    constructor(data: any) {
      this.claims = data.claims
    }
  
    isAuthenticated(): boolean {
      return !!this.claims.email
    }
  }


class CurrentUserService {
  http: AxiosInstance

  constructor() {
    this.http = axios.create({
      baseURL: "/api",
      withCredentials: true
    })
  }

  async current(): Promise<CurrentUser> {
    const response = await this.http.get('me')
    return new CurrentUser(response.data)
  }
}


export {
  CurrentUser,
  CurrentUserService
}